import { ref, onMounted } from 'vue'

export default {
    props: {
        field: {
            type: Object,
            default: undefined,
        },
    },
    setup(props) {

        // DOM
        const refSelect = ref()

        // Reactive data
        const currentLabel = ref(props.options?.[0])

        // Methods
        const updateLabel = e => {
            const label = props.options.find(o => o.value === e.target.value)
            currentLabel.value = label
        }

        // Lifecycle
        onMounted(() => {
            if(props.defaultValue) {
                const option = JSON.parse(props.defaultValue)
                currentLabel.value = option
                refSelect.value.value = option.value
            }
        })

        return {
            refSelect,
            currentLabel,
            updateLabel,
        }
    },
    template: `
        <transition name="v-transition-form-error">
            <span
                v-if="field?.$errors?.length > 0"
                class="a-form-error"
            >&uarr; {{ field.$errors[0].$message }}</span>
        </transition>
    `
}
